import GATSBY_COMPILED_MDX from "/var/www/html/adapthabitat.fr/src/realisations/arras.mdx";
import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import Grid from "../components/grid";
import Row from "../components/row";
import Col from "../components/col";
import Banner from "../components/banner";
import Compare from "../components/compare";
import {getImage, GatsbyImage} from "gatsby-plugin-image";
import "./blog-post.scss";
import BreadCrumb from "../components/breadcrumb";
import Card from "../components/card";
import {Link} from "gatsby";
function RealisationPost(props) {
  var _beforeImage$childIma, _before$childImageSha, _afterImage$childImag, _after$childImageShar;
  const {data: {mdx: {frontmatter: {label, title, h1, slug, before, after, beforeAlt, afterAlt}, beforeImage, afterImage}, similarRealisations: allMdx}, children} = props;
  const beforeData = getImage(beforeImage === null || beforeImage === void 0 ? void 0 : (_beforeImage$childIma = beforeImage.childImageSharp) === null || _beforeImage$childIma === void 0 ? void 0 : _beforeImage$childIma.gatsbyImageData) || getImage(before === null || before === void 0 ? void 0 : (_before$childImageSha = before.childImageSharp) === null || _before$childImageSha === void 0 ? void 0 : _before$childImageSha.gatsbyImageData);
  const afterData = getImage(afterImage === null || afterImage === void 0 ? void 0 : (_afterImage$childImag = afterImage.childImageSharp) === null || _afterImage$childImag === void 0 ? void 0 : _afterImage$childImag.gatsbyImageData) || getImage(after === null || after === void 0 ? void 0 : (_after$childImageShar = after.childImageSharp) === null || _after$childImageShar === void 0 ? void 0 : _after$childImageShar.gatsbyImageData);
  const realisations = allMdx.edges.map(similarRealisation => {
    var _node$beforeImage, _node$beforeImage$chi, _node$frontmatter$bef, _node$frontmatter$bef2, _node$afterImage, _node$afterImage$chil, _node$frontmatter$aft, _node$frontmatter$aft2;
    const node = similarRealisation.node;
    const before = getImage((_node$beforeImage = node.beforeImage) === null || _node$beforeImage === void 0 ? void 0 : (_node$beforeImage$chi = _node$beforeImage.childImageSharp) === null || _node$beforeImage$chi === void 0 ? void 0 : _node$beforeImage$chi.gatsbyImageData) || getImage((_node$frontmatter$bef = node.frontmatter.before) === null || _node$frontmatter$bef === void 0 ? void 0 : (_node$frontmatter$bef2 = _node$frontmatter$bef.childImageSharp) === null || _node$frontmatter$bef2 === void 0 ? void 0 : _node$frontmatter$bef2.gatsbyImageData);
    const after = getImage((_node$afterImage = node.afterImage) === null || _node$afterImage === void 0 ? void 0 : (_node$afterImage$chil = _node$afterImage.childImageSharp) === null || _node$afterImage$chil === void 0 ? void 0 : _node$afterImage$chil.gatsbyImageData) || getImage((_node$frontmatter$aft = node.frontmatter.after) === null || _node$frontmatter$aft === void 0 ? void 0 : (_node$frontmatter$aft2 = _node$frontmatter$aft.childImageSharp) === null || _node$frontmatter$aft2 === void 0 ? void 0 : _node$frontmatter$aft2.gatsbyImageData);
    return React.createElement(Col, {
      xs: 12,
      md: 6,
      lg: 4,
      className: "gap-2",
      key: node.id
    }, React.createElement(Link, {
      to: "/nos-realisations/" + node.frontmatter.slug + "/",
      style: {
        height: "100%"
      }
    }, React.createElement(Card, {
      className: "fill-container"
    }, before && after && React.createElement(Card.Image, null, React.createElement(Compare, {
      before: React.createElement(GatsbyImage, {
        image: before,
        alt: node.frontmatter.beforeAlt
      }),
      after: React.createElement(GatsbyImage, {
        image: after,
        alt: node.frontmatter.afterAlt
      })
    })), !before && after && React.createElement(Card.Image, null, React.createElement(GatsbyImage, {
      image: after,
      alt: node.frontmatter.afterAlt
    })), React.createElement(Card.Title, null, React.createElement("h2", null, node.frontmatter.label)), React.createElement(Card.Content, null, node.frontmatter.description))));
  });
  return React.createElement(Layout, {
    className: "blog-post"
  }, React.createElement(Banner, {
    color: "linear-gradient(90deg, #264653, #2a9d8f)",
    opacity: 1,
    className: "dark"
  }, React.createElement(Banner.Content, null, React.createElement("h1", {
    className: "banner__title"
  }, h1))), React.createElement(Grid, null, React.createElement(Row, {
    className: "narrow"
  }, React.createElement(Col, {
    xs: 12
  }, React.createElement(BreadCrumb, null, React.createElement(BreadCrumb.Item, {
    href: "/",
    title: "Accueil",
    position: 1,
    disabled: false
  }, "Accueil"), React.createElement(BreadCrumb.Item, {
    href: "/nos-realisations/",
    title: "Nos R\xE9alisations",
    position: 2,
    disabled: false
  }, "Nos r\xE9alisations"), React.createElement(BreadCrumb.Item, {
    href: "/nos-realisations/" + slug + "/",
    title: title,
    position: 3,
    disabled: true
  }, label)))), React.createElement(Row, {
    className: "narrow center blog-post__content"
  }, beforeData && afterData && React.createElement(Col, {
    xs: 12,
    className: "gap-3"
  }, React.createElement(Compare, {
    before: React.createElement(GatsbyImage, {
      image: beforeData,
      alt: beforeAlt
    }),
    after: React.createElement(GatsbyImage, {
      image: afterData,
      alt: afterAlt
    })
  })), !beforeData && afterData && React.createElement(Col, {
    xs: 12,
    className: "gap-3 single-image"
  }, React.createElement(GatsbyImage, {
    image: afterData,
    alt: afterAlt
  })), React.createElement(Col, {
    xs: 12,
    className: "gap-3"
  }, React.createElement("div", null, children))), React.createElement(Row, {
    className: "narrow stretch"
  }, React.createElement(Col, {
    xs: 12
  }, React.createElement("h2", {
    className: "h2"
  }, "Ces r\xE9alisations peuvent aussi vous int\xE9resser")), realisations)));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(RealisationPost, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const Head = props => {
  var _afterImage$childImag2, _after$childImageShar2, _afterData$images, _afterData$images$fal;
  const {data: {mdx: {frontmatter: {title, slug, after, description, date}, afterImage}}} = props;
  const afterData = getImage(afterImage === null || afterImage === void 0 ? void 0 : (_afterImage$childImag2 = afterImage.childImageSharp) === null || _afterImage$childImag2 === void 0 ? void 0 : _afterImage$childImag2.gatsbyImageData) || getImage(after === null || after === void 0 ? void 0 : (_after$childImageShar2 = after.childImageSharp) === null || _after$childImageShar2 === void 0 ? void 0 : _after$childImageShar2.gatsbyImageData);
  return React.createElement(SEO, {
    title: title,
    description: description,
    image: afterData === null || afterData === void 0 ? void 0 : (_afterData$images = afterData.images) === null || _afterData$images === void 0 ? void 0 : (_afterData$images$fal = _afterData$images.fallback) === null || _afterData$images$fal === void 0 ? void 0 : _afterData$images$fal.src,
    pathname: "/nos-realisations/" + slug + "/",
    article: true
  }, React.createElement("script", {
    type: "application/ld+json"
  }, "\n          {\n            \"@context\": \"https://schema.org\",\n            \"@type\": \"Article\",\n            \"headline\": \"" + title + "\",\n            \"datePublished\": \"" + date + "\",\n            \"author\": {\n              \"@type\": \"Person\",\n              \"name\": \"Thierry Bajeux\"\n            }\n          }\n        "));
};
const pageQuery = "3545601992";
